import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { setupUntilDestroy } from '../component-utils';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButtonModule } from '@angular/material/button';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ApplicationWebService, CreditorWatchReportData, GetWebServiceReportFn } from '@portal-workspace/grow-shared-library';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { bureauReportDownloadTarget, openAuthorizedBureauReport } from '../credit-component/open-bureau-report-download';

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    selector: 'accreditation-report',
    templateUrl: './accreditation-report.component.html',
    styleUrls: ['./accreditation-report.component.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, PdfViewerModule]
})
export class AccreditationReportComponent implements OnInit {
  subscriptions: Subscription[] = [];
  pdf!: Uint8Array;
  reportHtml!: SafeHtml;
  webService!: ApplicationWebService;
  webServiceId!: number;
  webServiceType!: string;

  @Input({required: true}) getWebServiceReportFn!: GetWebServiceReportFn;
  @Input({required: true}) apiUrl!: string;
  @Output() leaveReport: EventEmitter<void> = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private toastService: PortalHotToastService,
  ) {}

  ngOnInit(): void {
    setupUntilDestroy(this);
    this.webServiceId = this.route.snapshot.params['innerTabParam'];

    if (this.webServiceId) {
    this.subscriptions.push(
      this.getWebServiceReportFn(this.webServiceId).pipe(
        this.toastService.spinnerObservable()
        ).subscribe(response => {
          console.log('======= Response', response);
          if (response && response.data) {
            this.webService = response.webService;
            this.webServiceType = this.webService.type;
            if (this.webServiceType === 'EquifaxFraudCheck') {
              this.reportHtml = this.sanitizer.bypassSecurityTrustHtml(response.data);
            }
            if (this.webServiceType !== 'EquifaxFraudCheck') {
              this.base64ToArrayBuffer(response.data);
            }
        } else {
            this.onLeaveReport();
            const errorMessage = 'Report not found';
            this.toastService.error(errorMessage);
        }
      })
    );
    }

  }

  onLeaveReport(): void {
    this.leaveReport.emit();
  }

  onDownloadReport(): void {
    if (!this.webService) {
      return;
    }
    const pdfRequestId = this.webService.type === 'CreditorWatch'
      ? (this.webService.json as CreditorWatchReportData).pdfRequestId
      : undefined;
    const target = bureauReportDownloadTarget(this.webService.type, this.webService.id, pdfRequestId);
    if (!target) {
      return;
    }
    openAuthorizedBureauReport(this.apiUrl, target.kind, target.resourceId).catch(() => {
      this.toastService.error('Unable to download report');
    });
  }

  base64ToArrayBuffer(base64: string) {
    let binary_string =  window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++)        {
      bytes[i] = binary_string.charCodeAt(i);
      
    }
    this.pdf = (bytes.buffer as Uint8Array);
  }
} 